export default "__VITE_ASSET__C0R0thrR__"